import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'Vendors' })({
    content: {
        marginTop: 24,
        display: 'flex',
        flexDirection: 'column',
        gap: 24
    },
    link: {
        color: '#232323',
        fontSize: 13,
        fontWeight: 500,
        lineHeight: '150%',
        letterSpacing: '-0.26px',
        textDecorationLine: 'underline',
        transition: 'opacity 0.2s',
        '&:hover': {
            color: '#232323',
            opacity: 0.7
        }
    }
});
